import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const CollapsibleHeader = ({
  title = "Header",
  children,
  defaultOpen = true,
  className = "",
  contentClassName = "",
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`w-full ${className}`}>
      <div className={`${open ? "block" : "hidden"} md:block ${contentClassName}`}>
        {children}
      </div>
      <div className="mt-1 flex justify-center md:hidden">
        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-dorika-blue bg-dorika-blueLight text-dorika-blue shadow-sm"
          aria-label={open ? `Hide ${title}` : `Show ${title}`}
          aria-expanded={open}
        >
          {open ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </button>
      </div>
    </div>
  );
};

export default CollapsibleHeader;
